import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { typeAlert, variantsAvatar, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import LocalStorageService from "../../services/localStorage";
import { menuItem, selectValueDefault } from "./resource/data";
import { PermisionView } from "./view";
import showToast from "../../services/toast";
import { ColumnsPermissions, rolDataForm, } from "./resource/data.Dto";
import { usePermissionGetAll } from "../../fnx/permission/permissionGetAll";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
import { permissionClearData } from "../../store/permissions/actions";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var PermissionAdmin = function () {
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var _a = useState(false), triggerPermission = _a[0], setTriggerPermission = _a[1];
    var _b = useState([]), permissionList = _b[0], setPermissionList = _b[1];
    var _c = useState(false), openModal = _c[0], setOpenModal = _c[1];
    var _d = useState(false), openModalDelete = _d[0], setOpenModalDelete = _d[1];
    var _e = useState(false), openModalDeletePermission = _e[0], setOpenModalDeletePermission = _e[1];
    var _f = useState(1), pageCatalog = _f[0], setPageCatalog = _f[1];
    var _g = useState(20), limitCatalog = _g[0], setLimitCatalog = _g[1];
    var _h = useState(0), countPag = _h[0], setCountPag = _h[1];
    // const [permissionList, setPermissionList] = useState([]);
    var _j = useState([]), permissionL = _j[0], setPermissionL = _j[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _k = useState(false), isUpdate = _k[0], setIsUpdate = _k[1];
    var _l = useState(false), openDrawerPermission = _l[0], setOpenDrawerPermission = _l[1];
    var _m = useState(null), itemModal = _m[0], setItemModal = _m[1];
    var _o = useState(""), nameSearch = _o[0], setNameSearch = _o[1];
    // const [bodyRequest, setBodyRequest] = useState<RolRequest>();
    var _p = useState(rolDataForm), dataForm = _p[0], setDataForm = _p[1];
    var _q = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _q[0], setSeeToast = _q[1];
    var _r = React.useState(""), titleDelete = _r[0], setTitleDelete = _r[1];
    var _s = React.useState(""), subTitleDelete = _s[0], setSubTitleDelete = _s[1];
    var _t = React.useState(""), permissionId = _t[0], setPermissionId = _t[1];
    /*Llamada al getAll para recuperar todos los permisos*/
    var _u = usePermissionGetAll(triggerPermission, clientId, pageCatalog, limitCatalog, nameSearch), responsePermission = _u.responsePermission, errorPermission = _u.errorPermission, loadingPermission = _u.loadingPermission;
    /*Llamada al POST */
    /*Llamada al Patch*/
    /*Llamada al Disable*/
    var clickContextMenuPaymentMode = function (item) {
        var _a;
        setOpenModalDeletePermission(true);
        setTitleDelete("Permisos");
        setSubTitleDelete("el permiso ".concat((_a = item.description) === null || _a === void 0 ? void 0 : _a.toLowerCase()));
        setPermissionId(item.id ? item.id : "");
        setIsUpdate(true);
        // showEdit(item);
        /*Unifica listas quita duplicados y actualiza */
        var listPermissionDb = itemModal.permission.map(function (rol) { return rol.id; });
        //Quita el ID que deseo de la lista
        var updatedListPermissionDb = listPermissionDb.filter(function (id) { return id !== item.id; });
        //Actualiza la nueva lista de Permisos
        // setBodyRequest({
        //   id: itemModal.id,
        //   clientId: itemModal.clientId,
        //   RolName: itemModal.code,
        //   RolDescription: itemModal.type,
        //   Permissions: updatedListPermissionDb,
        // });
        setOpenDrawerPermission(false);
        setOpenModal(false);
    };
    var columnsPermissions = ColumnsPermissions(clickContextMenuPaymentMode);
    var callPermission = function () {
        setTriggerPermission(!triggerPermission);
    };
    /*habilita trigger para getAll api de Permisos*/
    useEffect(function () {
        callPermission();
    }, []);
    /*Valida respuesta del getAll y mapea objetos*/
    useEffect(function () {
        if (responsePermission && (responsePermission === null || responsePermission === void 0 ? void 0 : responsePermission.data.length) > 0) {
            var listPermission = responsePermission === null || responsePermission === void 0 ? void 0 : responsePermission.data.map(function (item) { return ({
                id: item.id,
                type: item.type,
                title: item.name,
            }); });
            setPermissionList(listPermission);
            setTriggerPermission(false);
            var lPermission = responsePermission === null || responsePermission === void 0 ? void 0 : responsePermission.data.map(function (item) { return ({
                id: item.id,
                description: item.description,
                name: item.name,
                type: item.type,
                enabled: item.enabled ? "Activo" : "Inactivo",
            }); });
            setPermissionL(lPermission);
            if (responsePermission === null || responsePermission === void 0 ? void 0 : responsePermission.pagingInfo) {
                setCountPag(responsePermission === null || responsePermission === void 0 ? void 0 : responsePermission.pagingInfo.totalItems);
            }
            dispatch(permissionClearData());
        }
        else if (responsePermission && (responsePermission === null || responsePermission === void 0 ? void 0 : responsePermission.length) === 0) {
            setTriggerPermission(false);
            setPermissionList([]);
        }
    }, [responsePermission]);
    /*Valida respuesta de la creacion del ROL*/
    /*Valida respuesta del update del ROL*/
    /*Valida respuesta del disable del ROL*/
    var onClickClearData = function (Data) {
        // Valida clean filtro y limpia los filtros
        if (Data.filter.type_filter === "empty") {
            // setValueDescription(undefined);
            // setValueName(undefined);
        }
        // Llama a la consulta general sin filtros
        callPermission();
    };
    /*Mapea los filtros para enviarlos al API para busqueda*/
    var onClickApplyFilter = function (Data) {
        if (Data.filter.type_filter === "name") {
            // setValueName(Data.filter.filter_value);
            // setValueDescription(undefined);
        }
        else if (Data.filter.type_filter === "description") {
            // setValueDescription(Data.filter.filter_value);
            // setValueName(undefined);
        }
        callPermission();
    };
    var searchFilter = function (term) {
        console.log(term);
        if (term.length > 3) {
            setNameSearch(term);
            setTriggerPermission(true);
        }
        else if (term.length === 0) {
            setNameSearch("");
            setTriggerPermission(true);
        }
    };
    var newItem = function () {
        setDataForm({
            id: "",
            clientId: "",
            RolName: "",
            RolDescription: "",
        });
    };
    var onCloseSearch = function () {
        setNameSearch("");
        setTriggerPermission(true);
    };
    var handleOnClickAdd = function () {
        newItem();
        setIsUpdate(false);
        setOpenDrawerPermission(true);
    };
    /*Mapea el objeto para enviar en el POST*/
    var handleSubmitPermission = function (dataRol) {
        if (isUpdate) {
            // setBodyRequest({
            //   id: dataRol.id,
            //   clientId: dataRol.clientId,
            //   RolName: dataRol.RolName,
            //   RolDescription: dataRol.RolDescription,
            // });
            // setTriggerPatch(true);
            setOpenDrawerPermission(false);
        }
        else {
            // setBodyRequest({
            //   RolName: dataRol.RolName,
            //   RolDescription: dataRol.RolDescription,
            // });
            // setDataForm(rolDataForm);
            setOpenDrawerPermission(false);
            // setTriggerPost(true);
        }
        setOpenModal(false);
    };
    var handleOpenModal = function () {
        setOpenModal(true);
    };
    var onClickContextMenu = function (opt, item) {
        switch (opt.id) {
            case "1":
                setIsUpdate(true);
                setOpenDrawerPermission(true);
                // showEdit(item);
                break;
            case "2":
                setOpenModalDelete(true);
                setItemModal(item);
                break;
            case "3":
                // const listPermissionDb: RolPermission[] = item.permission?.map(
                //   (item: RolPermission) => ({
                //     id: item.id,
                //     name: item.name,
                //     description: item.description,
                //   }),
                // );
                setItemModal(item);
                setIsUpdate(true);
                // showEdit(item);
                setOpenDrawerPermission(true);
                break;
        }
    };
    var clickView = function (view) {
        setItemModal(view);
    };
    var onCloseDrawerPermissions = function () {
        setOpenDrawerPermission(false);
    };
    var handleCloseModal = function () {
        setOpenModal(false);
    };
    var handleDelete = function () {
        setOpenModalDelete(false);
        // setTriggerDisable(true);
    };
    var handleDeletePermission = function () {
        setOpenModalDeletePermission(false);
        // setTriggerPatch(true);
    };
    var onChangePage = function (e) {
        setPageCatalog(e);
        setTriggerPermission(true);
    };
    var onChangeRowsPerPage = function (e) {
        setLimitCatalog(e);
        setTriggerPermission(true);
    };
    return (_jsxs(React.Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loadingPermission, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: "Cargando roles..." }), _jsx(PermisionView, { title: "Permiso", titleDrawer: isUpdate ? "Modificar Permiso" : "Agregar Permiso", list: permissionList, avatarVariant: variantsAvatar.rounded, openModal: openModal, onSaveData: handleSubmitPermission, 
                // dataForm={permissionList}
                modalTitle: itemModal === null || itemModal === void 0 ? void 0 : itemModal.title, editMode: isUpdate, clickView: clickView, onSubmit: handleDelete, onClose: handleCloseModal, onCloseSearch: onCloseSearch, openDrawer: openDrawerPermission, setOpenDrawer: setOpenDrawerPermission, openModalDelete: openModalDelete, setOpenModalDelete: setOpenModalDelete, onCloseDrawer: onCloseDrawerPermissions, searchFilter: searchFilter, handleOpenModal: handleOpenModal, onClickContextMenu: onClickContextMenu, onClickAdd: handleOnClickAdd, onClickCancel: handleCloseModal, onFilterApply: onClickApplyFilter, onFilterEmpty: onClickClearData, selectValueDefault: selectValueDefault, menuItem: menuItem, 
                //View List
                columnsPermissions: columnsPermissions, rowsPermissions: permissionL, countPagination: countPag, limitCatalog: limitCatalog, onChangeRowsPerPage: onChangeRowsPerPage, onChangePage: onChangePage, pageCatalog: pageCatalog })] }));
};
